import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { CheckIcon } from 'lucide-react';
import { ImageGallery } from '../components/ImageGallery';
export default function CyprusPage() {
  const cyprusImages = [{
    src: 'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
    alt: 'Beautiful Cyprus coastline'
  }, {
    src: 'https://images.unsplash.com/photo-1586861256632-52a3db3369be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Cyprus mountains and olive groves'
  }, {
    src: 'https://images.unsplash.com/photo-1527824404775-dce343118ebc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Ancient ruins in Cyprus'
  }, {
    src: 'https://images.unsplash.com/photo-1580757746866-2f68fae4d6d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Traditional Cypriot village'
  }];
  const visualImpressions = [{
    src: 'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
    alt: 'Cyprus coastal path',
    description: 'Stunning coastal paths with breathtaking views of the Mediterranean Sea'
  }, {
    src: 'https://images.unsplash.com/photo-1602088693770-a2adc828d239?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1167&q=80',
    alt: 'Troodos mountains',
    description: 'Explore the majestic Troodos mountains with their unique flora and fauna'
  }, {
    src: 'https://images.unsplash.com/photo-1527824404775-dce343118ebc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    alt: 'Ancient ruins',
    description: 'Discover ancient ruins and archaeological sites dating back thousands of years'
  }, {
    src: 'https://images.unsplash.com/photo-1580757746866-2f68fae4d6d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Traditional village',
    description: 'Visit traditional villages where time seems to stand still'
  }];
  return <div className="flex flex-col min-h-screen w-full" data-id="element-382">
      <Header data-id="element-383" />
      <main className="flex-grow" data-id="element-384">
        {/* Hero Section */}
        <section className="relative w-full h-[60vh] bg-cover bg-center" data-id="element-385">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80')"
        }} data-id="element-386">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-387"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-388">
            <div className="max-w-3xl text-white" data-id="element-389">
              <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-390">
                Walking trip Cyprus with a local guide
              </h1>
              <p className="text-lg md:text-xl mb-8" data-id="element-391">
                Discover the rich nature, history, and culture Cyprus during our
                hiking weeks on the island. From the rugged mountains of the
                Troodos to the hidden bays along the coast, Cyprus offers a
                variety of landscapes that invite discovery. The island paths
                wind through vineyards, forests, and ancient villages where time
                seems to stand still. Every step brings you closer to the
                island's rich history, from ancient ruins and medieval
                monasteries to the heritage of Byzantine and Roman times.
              </p>
              <a href="/join" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md text-center inline-block transition duration-300" data-id="element-392">
                Join a Trip
              </a>
            </div>
          </div>
        </section>
        {/* Trip Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-393">
          <div className="container mx-auto px-4" data-id="element-394">
            <div className="text-center mb-12" data-id="element-395">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-396">
                Our Cyprus Hiking Trips
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-397">
                Explore the stunning landscapes and rich culture of Cyprus with
                our guided hiking tours
              </p>
            </div>
            <div className="grid grid-cols-1 gap-8 max-w-4xl mx-auto" data-id="element-398">
              {/* Trip 1 */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-399">
                <div className="relative h-64" data-id="element-400">
                  <img src="https://images.unsplash.com/photo-1527824404775-dce343118ebc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Cyprus Autumn Try-out Trip" className="w-full h-full object-cover" data-id="element-401" />
                </div>
                <div className="p-6" data-id="element-402">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-403">
                    Cyprus Autumn Try-out Trip
                  </h3>
                  <p className="text-teal-600 font-semibold mb-4" data-id="element-404">
                    15 - 22 October 2025
                  </p>
                  <p className="text-gray-600 mb-6" data-id="element-405">
                    Join us on this try-out trip to Cyprus! Explore new paths,
                    experience the island's authentic side, and help improve the
                    trip for future travelers.
                  </p>
                  <div className="space-y-2 mb-6" data-id="element-406">
                    <div className="flex items-start" data-id="element-407">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-408" />
                      <span className="text-gray-700" data-id="element-409">
                        Small group (max. 10 people)
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-410">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-411" />
                      <span className="text-gray-700" data-id="element-412">
                        Local guide with extensive knowledge of Cyprus
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-413">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-414" />
                      <span className="text-gray-700" data-id="element-415">
                        Varied hikes through mountains, coastal paths, and
                        ancient sites
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-800 font-medium mb-6" data-id="element-416">
                    8-day hiking trip from € 795,- per person
                  </p>
                  <a href="/trips/cyprus-autumn" className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-417">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Cyprus Gallery Section */}
        <section className="py-16 w-full" data-id="element-418">
          <div className="container mx-auto px-4" data-id="element-419">
            <ImageGallery images={cyprusImages} data-id="element-420" />
            <div className="max-w-4xl mx-auto mt-12" data-id="element-421">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-422">
                Our experience with walking holidays in Cyprus
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-423">
                Our time in Cyprus was more than just a trip—it was an adventure
                that confirmed what we already knew: this island is a discovery
                waiting to be made.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-424">
                We explored the vibrant cities, where ancient history seamlessly
                blends into modern life. From the coastal city of Paphos to
                hidden corners filled with stories from the past, every place we
                visited had its own unique character. But it was when we
                ventured into the Troodos Mountains that we truly fell in love
                with Cyprus. Here, the paths were less traveled, the air fresh
                and clear, and the views simply breathtaking. We walked through
                remote villages where time seemed to stand still, tasted the
                flavors of local wines, and found peaceful spots that seemed
                untouched for centuries.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-425">
                This experience convinced us that Cyprus is the perfect
                destination for anyone looking to explore nature, history, and
                culture all in one. It's a place where adventure and serenity
                come together, and where every path leads to something
                unforgettable. That's why we can't wait to share this beautiful
                island with you—beyond the well-known tourist spots, into the
                true heart of Cyprus.
              </p>
              <p className="text-lg italic text-gray-600 mb-6" data-id="element-426">
                This offer is covered by the STO Garant guarantee. You can find
                the conditions for this guarantee scheme on STO Garant's website
                (www.sto-garant.nl/en/downloads).
              </p>
            </div>
          </div>
        </section>
        {/* Visual Impression Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-427">
          <div className="container mx-auto px-4" data-id="element-428">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12 text-center" data-id="element-429">
              A Visual Impression
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-430">
              {visualImpressions.map((image, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-431">
                  <div className="h-64 overflow-hidden" data-id="element-432">
                    <img src={image.src} alt={image.alt} className="w-full h-full object-cover transform hover:scale-105 transition duration-500" data-id="element-433" />
                  </div>
                  <div className="p-4" data-id="element-434">
                    <p className="text-gray-700" data-id="element-435">{image.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-436" />
      </main>
      <Footer data-id="element-437" />
    </div>;
}